/*
 * Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

export class Constants {
    public static readonly STORE_CUSTOMER = 'customersStore';
    public static readonly GET_ACCESSTOKEN = 'GetAccessToken';
    public static readonly RENEW_TOKEN = 'RenewToken';
    public static readonly APP_LOADED = 'OrgHierarchyAppLoaded';

    // Session Variable
    public static readonly SESSION_TOKEN = 'token';
    public static readonly SESSION_ROLES = 'roles';
    public static readonly SESSION_ORG_ID = 'organizationid';

    // TIMER CONFIGURATION's
    public static readonly API_TIMEOUT = 100000;

    // TOAST SEVERITY
    public static readonly TOAST_SEVERITY_CRITICAL = 'critical';
    public static readonly TOAST_SEVERITY_IMPORTANT = 'important';
    public static readonly TOAST_SEVERITY_INFORMATION = 'information';
    public static readonly TOAST_SEVERITY_SUCCESS = 'success';

    // CUSTOMER TOAST MESSAGES
    public static readonly CUSTOMER_ADD_SUCCESS = 'Create Customer';
    public static readonly CUSTOMER_ADD_FAILURE = 'Failed to create';
    public static readonly CUSTOMER_UPDATE_SUCCESS = 'Update Customer';
    public static readonly CUSTOMER_UPDATE_FAILURE = 'Failed to update';

    public static readonly CUSTOMER_DETAIL_MESSAGE_ADD_SUCCESS = 'Customer successfully created';
    public static readonly CUSTOMER_DETAIL_MESSAGE_ADD_FAILURE = 'Failed to create the customer';
    public static readonly CUSTOMER_DETAIL_MESSAGE_UPDATE_SUCCESS = 'Customer details successfully updated';
    public static readonly CUSTOMER_DETAIL_MESSAGE_UPDATE_FAILURE = 'Failed to update the customer details';

    // CUSTOMER VALIDATION
    public static readonly VALIDATION_CUSTOMER_NAME_REQUIRED = 'Customer name is required';
    public static readonly VALIDATION_CUSTOMER_NAME_DUPLICATE = 'Customer with the same name already exists';
    public static readonly VALIDATION_CUSTOMER_NAME_INVALID = 'Invalid Customer name';
    public static readonly VALIDATION_ADDRESS_LINE1_INVALID = 'Invalid Headquarter address line 1';
    public static readonly VALIDATION_ADDRESS_LINE2_INVALID = 'Invalid Headquarter address line 2';
    public static readonly VALIDATION_CUSTOMER_LOGO_REQUIRED = 'Logo is required';
    public static readonly VALIDATION_CUSTOMER_ADDRESS1_REQUIRED = 'Headquarter address line 1 is required';
    public static readonly VALIDATION_CUSTOMER_ADDRESS2_REQUIRED = 'Headquarter address line 2 is required';  
    public static readonly VALIDATION_LOGO_SIZE = 2097152; // 2 MB in bytes
    public static readonly VALIDATION_DATACENTER_REQUIRED = 'Data center is required';

    // CUSTOMER LABELS
    public static readonly CUSTOMER_TITLE_OF_PAGE = 'Customer Details';
    public static readonly CUSTOMER_TITLE_SELECT_OFFERING = 'Customer Details';
    public static readonly CUSTOMER_NAME_LABEL = 'Customer Name';
    public static readonly CUSTOMER_LOGO_LABEL = 'Customer logo';
    public static readonly CUSTOMER_LOGO_PREVIEW_LABEL = 'Customer logo Preview';
    public static readonly CUSTOMER_ADDRESS1_LABEL = 'Headquarter address line 1';
    public static readonly CUSTOMER_ADDRESS2_LABEL = 'Headquarter address line 2';
    public static readonly WIZARD_BTN_NEXT = 'NEXT';
    public static readonly WIZARD_BTN_SAVE = 'SAVE';
    public static readonly WIZARD_BTN_CANCEL = 'CANCEL';
    public static readonly CUSTOMER_PLACEHOLDER_LOGO = 'Drag and drop customer logo';
    public static readonly CUSTOMER_BROWSE_IMAGE_BUTTON_TEXT = 'BROWSE IMAGE';
    

    // CUSTOMER ADD EDIT TAB INFO
    public static readonly CUSTOMER_ADD_EDIT_TAB1_TITLE = 'Profile';
    public static readonly CUSTOMER_ADD_EDIT_TAB2_TITLE = 'Product';
    public static readonly CUSTOMER_ADD_HEADING = 'New Customer';
    public static readonly CUSTOMER_EDIT_HEADING = 'Edit Customer';
    public static readonly CUSTOMER_OFFERING_ENABLE_LABEL = 'Enable Product';

    // LODER MESSAGE
    public static readonly LOADER_SAVING = 'Saving...';
    public static readonly LOADER_LOADING = 'Loading...';

    
    // CUSTOMER CURRENCY RELATED CONSTANTS
    public static readonly ERROR_MODAL_TITLE = 'Customer Currency Not Selected';
    public static readonly ERROR_MODAL_SUBTITLE = "Please go to customer profile and select 'Customer currency'";
    public static readonly ERROR_MODAL_NTFCN_TITLE = 'Honeywell Forge For Buildings requires Customer Currency Details';
    public static readonly ERROR_MODAL_NTFCN_BODY =  "Honeywell Forge For Buildings product cannot be saved if 'customer currency' is not selected in the customer profile page.";
    public static readonly CTN_MDL_NTFCN_BODY =  'Default currency type once saved, cannot be changed';
    public static readonly CUR_ERROR =  'error';
    public static readonly CUSTOMER_CURRENCY_LABEL = 'Customer Currency';
    public static readonly CUSTOMER_CURRENCY_SELECT = 'Select';
    public static readonly CURRENCY_FEATURE_FLAG = 'portfolio-currency-configuration';    
    public static readonly CUSTOMER_CURRENCY_EDITABLE = 'customer-currency-editable';  
    public static readonly CUSTOMER_DATACENTER_LABEL = 'Customer Data Center';  
    public static readonly CUSTOMER_DATACENTER_SELECT = 'Select'; 
    public static readonly CUSTOMER_DATACENTER_FLAG = 'data-center-selection-for-customer'; 
    
}